// i18n area 'storage' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/storage.sr-Latn-RS.meta.json.
import type { enUS } from './storage'

export const srLatnRS: typeof enUS = {
  storage: {
    pools: {
      title: 'Storage',
      createTitle: 'Kreirajte storage',
      path: 'Putanja',
      pathHint: 'Apsolutna putanja pod dozvoljenim rootom (podrazumevano /var/lib/tvirt/pools/)',
      shared: 'Deljeni storage',
      sharedChip: 'deljeno',
      sharedVerifiedChip: 'deljeno · provereno',
      sharedVerifiedTooltip: 'Deljenje provereno: unakrsne sonde potvrđuju da svaki član vidi podatke koje su upisali drugi.',
      sharedDisputedChip: 'deljeno · NIJE provereno',
      sharedDisputedTooltip: 'Deljenje NIJE provereno',
      sharedDisputedPair: '{observer} ne vidi podatke koje je upisao {writer}',
      sharedHint: 'Mrežni share montiran lokalno na istoj putanji na svakom članu — preduslov live migracije (deklarativno).',
      sharedDanger: 'OPASNOST — TVirt VERUJE ovom flagu: kada ga uključite, svaki član pretpostavlja da na ovoj putanji vidi ISTE bajtove. Na fascikli koja NIJE zaista deljeni share (NFS/CIFS/klasterski filesystem) rezultat je oštećenje i gubitak podataka pri prvoj migraciji ili prvom HA restartu na drugom čvoru. Uključite ga samo ako je putanja share montiran identično na svakom čvoru.',
      type: 'Tip',
      capacity: 'Kapacitet',
      provisioned: 'Alocirano',
      provisionedOvercommit: 'Potencijalna obaveza iznad kapaciteta: thin volumeni mogu narasti do {n} GiB.',
      phase: { ready: 'Spreman', degraded: 'Degradiran', error: 'Greška' },

      // Round #156 (dialog standard): il dialog dettagli COMPLETO — tab,
      // le righe di config per-driver e la superficie osservata.
      tabConfig: 'Konfiguracija',
      tabCapacity: 'Kapacitet i stanje',
      cardIdentity: 'Identitet',
      cardPlacement: 'Smeštaj',
      cardConnection: 'Konekcija',
      usedReal: 'Stvarna zauzetost',
      capacityUnknown: 'Čvor još nije prijavio kapacitet ovog poola — ovde se brojevi ne izmišljaju',
      overcommitHint: 'Obaveza iznad kapaciteta: legitimno na thin poolovima, pratite stvarnu zauzetost',
      supportedContent: 'Podržani sadržaji',
      content: {
        disks: 'Diskovi',
        catalogFiles: 'Datoteke kataloga',
        backups: 'Bekapi',
        appVolumes: 'Volumeni aplikacija'
      },
      defaultDiskFormat: 'Podrazumevani format diska',
      reserveGiB: 'Rezervisan slobodan prostor (GiB)',
      available: 'Dostupno',
      diskCount: 'Diskovi',
      filesystem: 'Filesystem',
      observedAt: 'Posmatrano',
      lostAtRow: 'Proglašeno izgubljenim',
      sharedProbeRow: 'Provera deljenja',
      sharedProbeNodes: 'Sondirani čvorovi',
      reachableFrom: 'Deklarisana dostupnost',
      reachableFromHint: 'Čvorovi sa kojih ovaj storage mora biti dostupan. VM čiji diskovi, ISO-i ili metapodaci žive ovde ne pokreće se niti migrira na čvor van ove liste. Svi članovi su unapred izabrani — suzite po želji. Čvor koji kasnije uđe u klaster ostaje van dok ga ovde ne dodate.',
      reachableFromNone: 'nije deklarisana',
      reachableFromTags: 'Dostupnost po tagovima',
      reachableFromTagsHint: 'Selektor tag=vrednost (stavke odvojene zarezima, u AND-u): svaki član koji nosi ove tagove deklarisan je kao dostupan — dinamički: tagovanje čvora ga uvodi.',
      reachableFromTagsInvalid: 'Neispravan format — koristite tag=vrednost, odvojeno zarezima',
      reachableResolved: 'Razrešeni čvorovi: {nodes}',
      reachableDeclaredNotSeen: 'deklarisano, ali ne i viđeno sondom deljenja na: {nodes}',
      reachableSeenNotDeclared: 'viđeno, ali ne i deklarisano (van perimetra) na: {nodes}',
      cephCluster: 'Upravljani Ceph klaster',
      appGuardTitle: 'Storage koji koriste aplikacije',
      appEphemeralGuard: 'ovaj storage je klasterski efemerni pool aplikacija — najpre ga promenite na stranici Aplikacije, pa ga onda obrišite.',
      appInUseGuard: 'ovde žive rootovi/volumeni aplikacija: {apps} — najpre ih premestite ili obrišite.',
      releaseRequiredTitle: "Obrisati '{name}' i osloboditi njegove slike?",
      releaseRequiredBatchTitle: 'Obrisati izabrane storage i osloboditi njihove slike?',
      releaseRequiredBody: 'Oslobađanje slika ne briše NIJEDAN bajt: odjava ostavlja namespace na disku, slike jednostavno prestaju da budu materijalizovane, a svaka referenca scope-ova preživljava kao claim — ponovo registrujte pool i biće ponovo usvojene.',
      releaseConfirm: 'Obriši i oslobodi slike'
    },
    lost: {
      chip: 'Izgubljen',
      action: 'Proglasi izgubljenim',
      confirmTitle: 'Proglasite storage izgubljenim',
      confirmBody: 'Atestacija operatera na sopstveni deklarisani rizik: svaki zadatak u redu čekanja ili u toku koji cilja ovaj storage ili njegove objekte biće NEUSPEŠAN, brisanja postaju samo zapis u evidenciji (bez rada na filesystemu), a novi fizički rad se odbija. Bajtovi se nikada ne diraju — ako se volumen vrati u život, registrujte ga ponovo i pokrenite skeniranje da biste sve ponovo usvojili.',
      confirmSubmit: 'Proglasi izgubljenim',
      error: 'Atestacija je odbijena'
    },
    findings: {
      action: 'Pronađeni objekti',
      title: 'Pronađeni objekti',
      empty: 'Nijedan objekat nije pronađen u storage namespaceu',
      loadError: 'Pronađene objekte nije moguće učitati',
      actionError: 'Odluka je odbijena',
      colKind: 'Tip',
      colObject: 'Objekat',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Ovaj direktorijum je već inicijalizovalo drugo skladište: pečat identiteta prepisan je pečatom ovog skladišta. Sadržaj NIJE diran — pogledaj pronađene objekte ispod, uvezi one koji su ti potrebni, pa zatvori ovo obaveštenje.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Datoteka kataloga',
        vmMetadata: 'VM metapodaci',
        namespace: 'Namespace',
        foreign: 'Strano',
        volumeGroup: 'Grupa volumena'
      },
      vgAdopt: {
        action: 'Usvoji grupu volumena',
        title: 'Usvoji grupu volumena',
        intro:
          'Ovaj uređaj već nosi grupu volumena sa imenom TVirta, ali njen pečat ne imenuje nijedan ovde registrovan storage. Može biti ono što je prethodni storage OVOG klastera ostavio na LUN-u — ili ono što je DRUGI TVirt klaster ostavio na LUN-u koji je promenio vlasnika: odavde oba slučaja izgledaju isto, i zato niko ne odlučuje umesto vas.',
        irreversible: 'Pogledajte uređaj, pečat i ime pre nego što nastavite: usvajanje se ne poništava.',
        device: 'Uređaj',
        seal: 'Pečat',
        sealNone: 'nema (nema oznake tvirt.storageId)',
        renameTo: 'Biće preimenovana u',
        renameNone: 'Bez preimenovanja: ime je već ono koje ovaj storage izvodi',
        volumesNote:
          'Sadržani volumeni se ovim gestom NE usvajaju: sledeće skeniranje ih nudi jedan po jedan, kao obične pronađene objekte.'
      },
      conflictChip: 'ID već postoji',
      dismissedChip: 'Ignorisano',
      adopt: 'Usvoji',
      adoptFileTitle: 'Uvezite u katalog',
      adoptFileHint: 'Datoteke postoje samo unutar kataloga: izaberite odredišni katalog za pronađenu datoteku.',
      purge: 'Obriši sa diska',
      dismiss: 'Ignoriši',
      purgeConfirmTitle: 'Obrišite sa diska',
      purgeConfirmBody: 'Pronađeni bajtovi objekta {id} biće uklonjeni sa storagea. Operacija je nepovratna.',
      taskStarted: 'Pokrenuto — nastavlja se kao zadatak u pozadini',
      scan: 'Skeniraj storage',
      scanStarted: 'Skeniranje pokrenuto…',
      scanDone: 'Skeniranje završeno — pronađeni objekti su ažurirani'
    },
    reinit: {
      action: 'Ponovo pokušaj inicijalizaciju'
    },
    wizard: {
      addButton: 'Dodaj',
      title: 'Dodajte storage',
      back: 'Nazad',
      continue: 'Nastavi',
      selectHint: 'Izaberite protokol da biste videli kako ga TVirt koristi.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Eksportovana putanja',
      share: 'Share',
      username: 'Korisničko ime',
      password: 'Lozinka',
      passwordHint: 'Samo za upis: koristi se za mount, nikada se više ne prikazuje.',
      credential: 'Akreditiv',
      credentialManual: 'Unesi ručno',
      credentialHint: 'Stavka keystorea tipa korisničko ime i lozinka — alternativa njihovom ukucavanju ovde.',
      credentialEmpty: 'U keystoreu nema akreditiva tipa korisničko ime i lozinka — kreirajte ga u Sistem → Akreditivi, ili ukucajte nalog ispod.',
      options: 'Mount opcije',
      optionsHint: 'Odvojene zarezom, prosleđuju se mount -o doslovno.',
      portal: 'Portal',
      portalHint: 'host[:port] — podrazumevani port je 3260.',
      target: 'Target IQN',
      targetHint: 'Ime iSCSI targeta, počinje sa iqn.',
      lun: 'LUN',
      wholeLunRow: 'Na diskovima: ovaj storage imenuje samo target',
      wholeLunHint: 'Ovaj storage imenuje samo target: njegovi LUN-ovi postaju diskovi jedan po jedan (Napravi disk → preuzmi ceo LUN), na target se ništa ne piše.',
      lunHint: 'Broj LUN-a na targetu — 0 ako niste sigurni.',
      chapCredential: 'Akreditiv (CHAP)',
      chapCredentialHint: 'Stavka keystorea tipa CHAP (iSCSI) koja se koristi za login — tajna nikada ne putuje uz storage.',
      chapNone: 'Bez autentifikacije',
      chapEmpty: 'U keystoreu nema akreditiva tipa CHAP (iSCSI) — kreirajte ga u Sistem → Akreditivi. Bez njega login ostaje neautentifikovan.',
      address: 'Adresa',
      addressHint: 'Host ili IP NVMe/TCP targeta (traddr).',
      port: 'Port',
      portHint: 'TCP port targeta — 4420 ako se ostavi prazno.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN subsystema na targetu, počinje sa nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID unutar subsystema — 1 ako niste sigurni.',
      dhchapCredential: 'Akreditiv (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Stavka keystorea tipa DH-HMAC-CHAP (NVMe) koja se koristi pri povezivanju — tajna nikada ne putuje uz storage.',
      dhchapNone: 'Bez autentifikacije',
      dhchapEmpty: 'U keystoreu nema akreditiva tipa DH-HMAC-CHAP (NVMe) — kreirajte ga u Sistem → Akreditivi. Bez njega konekcija ostaje neautentifikovana.',
      monitors: 'Monitori',
      monitorsHint: 'Endpointi Ceph monitora, host[:port], odvojeni zarezom ili novim redom — podrazumevani port 6789.',
      pool: 'Pool',
      poolHint: 'RBD pool koji se koristi — jedna RBD slika po disku.',
      fs: 'Filesystem',
      fsHint: 'Ime CephFS filesystema (mds_namespace pri mountu).',
      fsPath: 'Putanja unutar filesystema',
      fsPathHint: 'Apsolutna putanja unutar filesystema koji storage montira — / ako ste u nedoumici.',
      cephxCredential: 'Akreditiv (cephx)',
      cephxCredentialHint: 'Stavka keystorea tipa cephx: username = ime klijenta (client.…), secret = base64 ključ. Obavezna.',
      cephxNone: 'U keystoreu nema cephx akreditiva — kreirajte jedan (tip: cephx) u Sistem → Akreditivi, ili pustite da ga upravljani Ceph klaster iskuje kroz „Predloži kao storage“.',
      sharedByNature: 'Storage preko mreže je po prirodi deljen: svaki član ga montira na istoj putanji kojom upravlja TVirt.',
      error: 'Storage je odbijen',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Ostalo',
        legacy: 'Legacy'
      },
      legacyHint: 'Podržani u potpunosti — samo ih ne bismo izabrali za novu instalaciju.',
      proto: {
        // La riga `usage` (Luca 2026-07-24) dice come TVirt usa il protocollo —
        // in primis i contenuti ammessi: dir/nfs/cifs ospitano dischi E immagini
        // ISO/disco e template, i driver a blocchi (iscsi/nvme-tcp/rbd) SOLO
        // dischi.
        dir: {
          name: 'Lokalna fascikla',
          desc: 'Direktorijum na čvoru: jednostavno i brzo. LOKALAN je za jedan čvor, osim ako putanja nije zaista deljeni share — označiti ga kao deljen kad nije košta podataka.',
          usage: 'TVirt u njemu čuva diskove VM-ova, ISO/disk slike i šablone.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS eksport koji klaster montira — deljen po prirodi.',
          usage: 'Drži diskove VM-ova, ISO/disk slike i šablone.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Windows/Samba share koji klaster montira — deljen po prirodi.',
          usage: 'Drži diskove VM-ova, ISO/disk slike i šablone.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Udaljeni filesystem preko SSH — bez potrebe za NAS eksportom.',
          usage: 'U roadmapu.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blok LUN-ovi preko IP-a sa deljenim LVM-om povrh.',
          usage: 'Samo diskovi — jedan thin volumen po disku; ne drži ISO slike ni šablone.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Distribuirani blok uređaji na Ceph klasteru.',
          usage: 'Samo diskovi — jedna RBD slika po disku, koju QEMU otvara nativno; ne drži ISO slike.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Distribuirani Ceph filesystem, koji kernel montira na klasteru — shared by nature.',
          usage: 'Drži VM diskove, ISO/disk slike i šablone — porodica dir na Ceph filesystemu (cephx akreditiv obavezan).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN-ovi preko FibreChannel fabrica — klasični FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Isti SCSI preko FibreChannela, sa FC frejmovima enkapsuliranim u Ethernet.' },

        // Vivo dal round #132 — la chiave è il nome del driver del contract,
        // così il chip della lista storage risolve la stessa voce.
        'iscsi-lun': {
          name: 'iSCSI (celi LUN-ovi)',
          desc: 'iSCSI target kao nosilac celih LUN-ova: svaki disk JESTE LUN, sirovo predat gostu — bez LVM-a između.',
          usage: 'Samo diskovi — jedan ceo LUN po disku, preuzet kakav jeste; SAN dom diskova sa deljenim pisanjem.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (celi namespace-ovi)',
          desc: 'NVMe podsistem kao nosilac celih namespace-ova: svaki disk JESTE namespace, sirovo predat gostu.',
          usage: 'Samo diskovi — jedan ceo namespace po disku, preuzet kakav jeste; deljeno pisanje da, SCSI persistent reservations ne.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Udaljeni NVMe — bez SCSI-ja u putanji — preko običnog TCP-a, sa deljenim LVM-om povrh.',
          usage: 'Samo diskovi — jedan thin volumen po disku; ne drži ISO slike ni šablone.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Udaljeni NVMe preko FibreChannel fabrica.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe preko FibreChannel fabrica koji FCoE prenosi unutar Etherneta — slojevi FCoE i NVMe/FC naslagani.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI sa putanjom podataka premeštenom na RDMA — bilo koji fabric (InfiniBand, iWARP, RoCE). Prevaziđen od strane NVMe/RDMA, i dalje prisutan u arrayima i u ESXi-ju.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Nativni SCSI preko RDMA, era pre iSER-a: InfiniBand (uz fabric discovery) i RoCE — preživljava u zastarelom HPC storageu.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Udaljeni NVMe preko bilo kog RDMA fabrica — InfiniBand, iWARP, RoCE v1 i v2: jedna konfiguracija, a čvor javlja koji ima.' },
        s3: { name: 'S3', desc: 'S3-kompatibilan object storage — slike i rezervne kopije.' }
      }
    },
    catalogs: {
      title: 'Katalozi',
      createTitle: 'Kreirajte katalog',
      editTitle: 'Izmenite katalog',
      docTitle: 'Katalog',
      notFound: 'Ovaj katalog (više?) ne postoji',
      scopeHint: 'Ko čita ovaj scope vidi (i može da koristi) svaku datoteku kataloga',
      files: 'Datoteke',
      noFiles: 'Nema datoteka',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT tpl',
        vmTemplate: 'VM tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmware'
      },

      // Il catalogo di sistema (round #126): la casa degli oggetti integrati
      // della piattaforma — leggibile da tutti, scrivibile da nessuno.
      systemChip: 'sistemski',
      systemTooltip: 'Sistemski katalog: drži ugrađene objekte platforme i ne može se menjati'
    },

    // File di catalogo (round K1, inventory v2e/v2g): il catalogo è la casa
    // degli artefatti file del cluster — una lista, titoli per kind.
    catalogFiles: {
      catalog: 'Katalog',
      kindLabel: 'Tip',
      physicalSize: 'Fizička veličina',
      virtualSize: 'Virtuelna veličina',

      // Round K3 (#64) + K4 (#65, ova/ovf con la mappatura boot-survival):
      // materializza un file vm-template come VM Template dell'inventario.
      importTemplateAction: 'Uvezi kao VM šablon',
      importTemplateLegacy: 'Nema deklarisanog formata — upotrebljivo kao seed za diskove, ne može se uvesti',
      importTemplateTitle: 'Uvezite kao VM šablon',
      importTemplateSubmit: 'Uvezi',
      importTemplateError: 'Uvoz nije uspeo',
      importTemplateHint: 'Paket .tvtpl postaje VM šablon: zamrznuti hardver iz manifesta plus jedan disk po stavci arhive, svaki proveren u odnosu na svoj checksum. NIC-ovi i CD/DVD mediji nisu deo arhive — dodajte ih posle uvoza.',
      importTemplateQcow2Hint: 'Goli qcow2 postaje šablon sa JEDNIM diskom i deklarisanim podrazumevanim hardverom: profil linux, UEFI, 2 vCPU, 2048 MiB, boot sa njegovog jedinog diska. Podesite pri deployu.',
      importTemplateName: 'Ime šablona',
      importTemplateNameHint: 'Prazno = {name} (-import-<n> ako je zauzeto)',
      importTemplateStorage: 'Storage za diskove',
      importTemplateMetadataStorage: 'Storage metapodataka',
      importTemplateMetadataHint: 'Blok storage ne drži VM metapodatke (firmware, varstore) — izaberite neki dir/nfs/cifs.',
      importTemplateStarted: 'Uvoz pokrenut — šablon se pojavljuje u tabu Šabloni po završetku zadatka.',

      // Etichette parlanti al singolare (#86): findings e censimento dicono
      // COSA è il file — il generico 'File di catalogo' resta solo fallback.
      kind: {
        iso: 'ISO slika',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM šablon',
        'oci-image': 'OCI slika',
        'firmware-ovmf': 'OVMF firmware'
      },
      title: {
        iso: 'ISO slike',
        'ct-rootfs': 'CT šabloni',
        'vm-template': 'VM šabloni',
        'oci-image': 'OCI slike',
        'firmware-ovmf': 'OVMF firmware'
      },
      createTitle: {
        iso: 'Dodajte ISO sliku',
        'ct-rootfs': 'Registrujte CT šablon',
        'vm-template': 'Dodajte VM šablon',
        'oci-image': 'Dodajte OCI sliku',
        'firmware-ovmf': 'Dodajte OVMF firmware'
      },
      formatHint: 'Izvedeno iz ekstenzije izabrane datoteke — ispravite ako je pogrešno pogodilo',
      tarballHint: 'Rootfs tarball u standardnom LXC formatu (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, ili običan .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar ili .tar.gz), na primer iz docker save',
      uploadResumeHint: 'Upload prekinut — datoteka čeka upload: pošaljite ponovo istu datoteku da biste nastavili',
      moveTitle: 'Premestite datoteku',
      moveHint: 'Dve nezavisne dimenzije: Katalog premešta vezu (isti id, nijedan bajt se ne pomera, scope postaje onaj odredišnog kataloga); Storage premešta podatke — svaka povezana kopija je prati, odbija se dok je datoteka u upotrebi. Izabrani zajedno: prvo katalog, pa storage.',
      moveCatalog: 'Odredišni katalog',
      moveCatalogHint: 'Samo veza menja dom: VM koja je montirala datoteku mora da vidi odredišni katalog',
      keepCurrent: 'Ne menjaj',
      rehomed: 'Veza premeštena u izabrani katalog',
      copyAction: 'Kopiraj u katalog…',
      copyTitle: 'Kopirajte u katalog',
      copyLinkHint: 'Kopija je nova veza ka istim podacima — ništa se ne duplira na storageu.',
      copyCatalog: 'Odredišni katalog',
      copyCatalogHint: 'Kopiranje je način na koji datoteka putuje između kataloga',
      sameCatalog: 'Isti kao izvor',
      sharedObjectHint: 'Podaci ove datoteke su deljeni — povezanih kopija: {count}',
      deleteLastLink: 'Ovo je POSLEDNJA veza ka ovom sadržaju: biće obrisani i podaci sa storagea.',
      deleteLinkOnly: 'Biće uklonjena samo ova veza — podaci ostaju, i dalje dostupni kroz ostale povezane kopije ({count}).',
      noCatalog: 'Još nema nijednog kataloga — kreirajte jedan',
      inlineCatalogName: 'Ime kataloga',

      // File integrati nella piattaforma (round #126): storage null — si
      // leggono e si clonano, mai move/delete/rename.
      embeddedChip: 'ugrađeno',
      embeddedStorage: 'Ugrađeno u platformu',
      embeddedNoMove: 'Ugrađena datoteka platforme: ne živi ni na jednom storageu — umesto toga je klonirajte',
      embeddedCopyHint: 'Klon materijalizuje ugrađene bajtove na pravi storage: izaberite odredišni storage i katalog — kopija je obična datoteka',
      sourceEmbedded: 'Ugrađeno u platformu',
      nodesRow: 'Prisustvo po čvoru',
      nodesSummary: '{present} od {total} čvorova ga ima',
      nodePresent: 'prisutan',
      nodeMissing: 'nedostaje',
      nodeUnknown: 'još nije prijavljeno',
      nodesHint: 'Aset živi na disku svakog čvora (paket trantor-tvirt-assets): čvor koji ga nema ne može ni da definiše VM sa ovim firmverom ni da služi Guest Tools. Različite verzije među čvorovima su normalne tokom postepenog ažuriranja.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'Preuzmi',
      downloadNotReady: 'Sadržaj još nije spreman — download zahteva datoteku u stanju ready',
      downloadDenied: 'Vaša uloga ne uključuje catalog.download — preuzimanje bajtova je pravo odvojeno od upotrebe datoteke',

      // Round #156 (dialog standard): le righe di lettura mancanti del dialog
      // dettagli — i fatti dell'oggetto condiviso, il checksum dichiarato, gli
      // utilizzatori.
      objectRow: 'Storage objekat',
      objectLinksRow: 'Povezane kopije',
      declaredChecksum: 'Deklarisani SHA-256',
      usedByRow: 'Koriste ga',
      usedByVms: 'VM-ovi',
      usedByDisks: 'Diskovi',
      transferRow: 'Prenos',
      storageLockHint: 'Menja se samo akcijom Premesti'
    },

    // Il censimento per-storage (round K1, inventory v2b #2): sola lettura,
    // ogni oggetto si gestisce dalla sua sezione.
    objects: {
      action: 'Istraži sadržaj',
      title: 'Sadržaj storagea',
      hint: 'Popis samo za čitanje onoga što živi na ovom storageu — svakim objektom se upravlja iz njegove sekcije.',
      empty: 'Nijedan objekat nije registrovan na ovom storageu',
      loadError: 'Sadržaj nije moguće učitati',
      colDetail: 'Detalj',
      manage: 'Upravljaj u njegovoj sekciji',
      kind: {
        disk: 'Disk',
        catalogFile: 'Datoteka kataloga',
        ociBlob: 'OCI blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM metapodaci',
        appRoot: 'Root aplikacije',
        appVolume: 'Volumen aplikacije'
      }
    },
    inventory: {
      tabCatalogs: 'Katalozi',
      storage: 'Storage',
      sizeGib: 'Veličina (GiB)',
      format: 'Format',
      size: 'Veličina',
      sourceType: 'Izvor',
      sourceFile: 'Otpremanje datoteke',
      sourceUrl: 'Download sa URL-a',
      file: 'Datoteka',
      url: 'URL',
      checksum: 'SHA-256 checksum',
      checksumHint: 'Obavezno: download se proverava u odnosu na ovaj SHA-256',
      verifyChecksum: 'Proveri checksum',
      checksumOffHint: 'Download će biti prihvaćen bez provere — izračunati SHA-256 se svejedno beleži',
      uploading: 'Otpremanje…',
      move: {
        action: 'Premesti',
        diskTitle: 'Premestite disk',
        target: 'Odredišni storage',
        diskHint: 'Disk zadržava svoj identitet: bajtovi putuju na izabrani storage. VM koji ga koristi mora biti ugašen; uz prisutne snimke iSCSI strana odbija premeštanje.',
        noTargets: 'Nema kompatibilnog odredišnog storagea',
        submit: 'Premesti',
        error: 'Premeštanje je odbijeno'
      },
      clone: {
        action: 'Kloniraj',
        title: 'Klonirajte disk',
        name: 'Ime kopije',
        storage: 'Odredišni storage',
        sameStorage: 'Isti kao izvor',
        linked: 'Linked clone',
        linkedHint: 'Trenutni qcow2 overlay ulančan na izvorni disk (samo qcow2 izvori). Podrazumevano je puna kopija.',
        linkedCrossHint: 'Linked clone ostaje na storageu izvora: izaberite „Isti kao izvor“ da biste ga omogućili.',
        submit: 'Kloniraj',
        error: 'Kloniranje je odbijeno'
      },
      copy: {
        action: 'Kopiraj',
        name: 'Ime kopije',
        storage: 'Odredišni storage',
        sameStorage: 'Isti kao izvor',
        submit: 'Kopiraj',
        error: 'Kopiranje je odbijeno'
      },
      taskStarted: 'Pokrenuto — nastavlja se kao zadatak u pozadini',
      cephObjects: 'Idi na detalje objekta na Cephu',
      phase: {
        ready: 'Spremna',
        creating: 'U kreiranju',
        'awaiting-upload': 'Čeka upload',
        downloading: 'U preuzimanju',
        verifying: 'U proveri',
        deleting: 'Briše se',
        error: 'Greška',
        'in-use': 'U upotrebi'
      }
    }
  }
}
